import React from "react";
import BasicMerchantEmailFrame from "@smartrr/shared/entities/CustomerEmailConfig/components/BasicMerchantEmailFrame";
import { BodyLg, HeadingSm } from "@smartrr/shared/entities/CustomerEmailConfig/components/Text";
import { RoundedButton } from "@smartrr/shared/entities/CustomerEmailConfig/components/RoundedButton";
import { appPrefixedHost } from "@smartrr/shared/constants";
import { formatTemplateVariable } from "@smartrr/shared/entities/CustomerEmailConfig/utils";

export interface EmailTemplateMerchantPriceChange {
  merchantName: string;
  affectedVariantsCount: number;
  affectedSubscriptionsCount: number;
  shopifyDomain: string;
}

/**
 * `<%- merchantPriceChange.VARIABLE %>`
 * @param merchantPriceChange.merchantName name of the merchant
 * @param merchantPriceChange.affectedVariantsCount number of affected variants
 * @param merchantPriceChange.affectedSubscriptionsCount number of affected subscriptions
 * @param merchantPriceChange.shopifyDomain shopify domain of the merchant
 */
export const MerchantPriceChangeEmail = () => {
  const reviewPriceChangesUrl = `https://${appPrefixedHost}/admin/bulk-updates?tab=price-changes&shop=${formatTemplateVariable("merchantPriceChange.shopifyDomain")}`;

  return (
    <BasicMerchantEmailFrame
      emailPreviewText="Review your subscription price changes"
      emailTitle="Review your subscription price changes"
      showSmartrrBanner
      showQuestionsFooter
    >
      <span>
        <HeadingSm data-testid="merchant-price-change__header" style={{ marginTop: 0, paddingBottom: "20px" }}>
          Review your subscription price changes
        </HeadingSm>
        <BodyLg style={{ paddingBottom: "20px" }}>
          Hi {formatTemplateVariable("merchantPriceChange.merchantName")},
        </BodyLg>
        <BodyLg data-testid="merchant-price-change__detected" style={{ paddingBottom: "20px" }}>
          We detected price changes in Shopify for products with active subscriptions.
        </BodyLg>
        <BodyLg style={{ paddingBottom: "20px" }}>
          Your existing subscription prices have not been changed automatically. Some subscriptions are still
          using the previous price, and you can choose whether to update them to the new Shopify price or keep
          their current subscription price.
        </BodyLg>
        <BodyLg data-testid="merchant-price-change__counts" style={{ paddingBottom: "20px" }}>
          Products or variants affected: {formatTemplateVariable("merchantPriceChange.affectedVariantsCount")}
          <br />
          Active subscriptions affected:{" "}
          {formatTemplateVariable("merchantPriceChange.affectedSubscriptionsCount")}
        </BodyLg>
        <RoundedButton
          data-testid="merchant-price-change__review-button"
          href={reviewPriceChangesUrl}
          style={{ maxWidth: "235px", marginBottom: "20px" }}
        >
          Review price changes
        </RoundedButton>
        <BodyLg style={{ paddingBottom: "20px" }}>
          You can review each price change and decide which subscriptions you want to update.
        </BodyLg>
        <BodyLg style={{ paddingBottom: "20px" }}>
          You can also find these changes anytime under Subscriptions → Bulk Updates → Price Changes.
        </BodyLg>
      </span>
    </BasicMerchantEmailFrame>
  );
};
